// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"51d0b1ce","390":"bfcb64cd","585":"98c96d8e","834":"2e732245"}[chunkId] + ".chunk.css";
};